/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './ColorIndicator.module.css';
export default function ColorIndicator({
    color,
    colorLight,
    percent = 100,
    shape = 'circle',
    size = 'md',
    showPercent = true,
    isActive = false,
    isEmpty = false,
    onClick,
    title,
    className = ''
}) {
    const containerClasses = [
        styles.container,
        styles[shape],
        styles[size],
        isActive ? styles.active : '',
        isEmpty ? styles.empty : '',
        onClick ? styles.clickable : '',
        className
    ].filter(Boolean).join(' ');
    const fillStyle = {
        height: `${percent}%`,
        '--fill-color': color,
        '--fill-color-light': colorLight || color,
        backgroundColor: color
    };
    return (
        <div className={containerClasses} onClick={onClick} title={title}>
            <div
                className={`${styles.fill} ${shape === 'circle' ? styles.gradient : ''}`}
                style={fillStyle}
            />
            {!isEmpty && showPercent && (
                <span className={styles.percentage}>{Math.round(percent)}%</span>
            )}
        </div>
    );
}
